import { findCollection } from '../../../../store/helpers/collections';

const toIds = (collectionIds) => [].concat(collectionIds || []).filter(Boolean);

export function isRootCollectionSelection(collectionIds, rootId) {
  const ids = toIds(collectionIds);
  return Boolean(rootId) && ids.length === 1 && ids[0] === rootId;
}

export function resolveCollectionFilterValue({
  collectionIds,
  collectionsTree,
  activeCollections = [],
}) {
  const ids = toIds(collectionIds);
  const activeMatches = activeCollections.length === ids.length
    && ids.every((id) => activeCollections.some((collection) => collection?._id === id));

  if (activeMatches && activeCollections.length) return activeCollections;

  return ids.map((collectionId) => (
    findCollection(collectionsTree, 'my', { _id: collectionId }) || { _id: collectionId }
  ));
}
